import $ from 'jquery';

class AjaxLogin {
	constructor() {
		this.link = $( '[data-show-login]' );
		this.wrapper = $( '[data-login-wrapper]' );
		this.close = $( '[data-hide-login]' );
		this.form = this.wrapper.find( 'form' );
		this.statusMsg = this.form.find( 'p.status' );
		this.orderWrapper = '';

		$( document ).ready( this.events.bind( this ) );
	}

	events() {
		this.link.on( 'click', this.showLogin.bind( this ) );
		this.close.on( 'click', this.closeLogin.bind( this ) );
		this.form.on( 'submit', this.doAjaxLogin.bind( this ) );
		document.addEventListener( 'click', this.outsideClickListener.bind( this ) );
	}

	showLogin( e ) {
		e.preventDefault();
		this.wrapper.fadeIn( 300 );

		/*if ( 0 !== this.wrapper.find( '[data-login-orders]' ).length ) {
			this.doAjaxShowOrders();
		}*/
	}

	closeLogin( e ) {
		e.preventDefault();

		this.hideLogin();
		this.removeClickListener();
	}

	hideLogin() {
		this.wrapper.hide();

		// Clear the ajax populated div
		this.wrapper.find( '[data-login-orders]' ).html( '' );
	}

	populateOrders( data ) {
		this.orderWrapper = this.wrapper.find( '[data-login-orders]' );

		// No orders to display
		if ( ! data.showOrders ) {
			this.orderWrapper.prepend( `<p class="order-info">
				${ data.message }
			</p>` );

			return;
		}

		// Show the orders
		this.orderWrapper.prepend( `<p class="order-info">
				${ data.message }
			</p>
			<div class="orders">${ data.orders }</div>
			<a href="" class="btn btn-secondary">Visa hela orderlistan</a>
		` );
	}

	outsideClickListener( e ) {
		if ( ! $( e.target ).closest( '[data-login-wrapper]' ).length && ! $( e.target ).closest( '[data-show-login]' ).length ) {
			if ( this.wrapper.is( ':visible' ) ) {
				this.hideLogin();
			}
		}
	}

	removeClickListener() {
		document.removeEventListener( 'click', this.outsideClickListener );
	}

	doAjaxShowOrders() {
		$.ajax( {
			context: this,
			type: 'POST',
			url: commonAjax.url, // eslint-disable-line no-undef
			dataType: 'json',
			data: {
				action: 'get_orders', //calls wp_ajax_get_orders
			},
			success( data ) {
				this.populateOrders( data );
			},
			error( data ) {
				alert( data ); // eslint-disable-line no-alert
			},
		} );
	}

	doAjaxLogin( e ) {
		this.statusMsg.show().text( ajaxLogin.loadingMessage ); // eslint-disable-line no-undef
		$.ajax( {
			context: this,
			type: 'POST',
			dataType: 'json',
			url: commonAjax.url, // eslint-disable-line no-undef
			data: {
				action: 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
				username: this.form.find( '[data-login="username"]' ).val(),
				password: this.form.find( '[data-login="password"]' ).val(),
				security: $( 'form#login #security' ).val(),
			},
			success( data ) {
				this.statusMsg.text( data.message );
				if ( true === data.loggedin ) {
					window.location.reload( false ); // Fetches the page from cache rather than server.
				}
			},
		} );
		e.preventDefault();
	}
}

export default AjaxLogin;
